import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Text,
} from '@kognitos/lattice';

/** Props for {@link AdvancedSection}. */
export interface IAdvancedSectionProps {
  children: ReactNode;
}

/**
 * A collapsed "Advanced" panel for settings most people leave alone, styled
 * like the configuration panel of poll and webhook triggers.
 *
 * @param props - Component props.
 * @returns The collapsible panel.
 */
export function AdvancedSection({ children }: IAdvancedSectionProps) {
  const { t } = useTranslation('credentials');
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full rounded-lg bg-secondary px-4"
    >
      <AccordionItem value="advanced">
        <AccordionTrigger className="hover:no-underline">
          <Text weight="medium">{t('credentials.create.advanced')}</Text>
        </AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
